import {AbstractControl} from '@angular/forms';

export class Digits {
  static digits(control: AbstractControl): { [key: string]: any } {
    const value = control.value;
    if (!/^(.*[0-9].*)/.test(value)) {
    // if (RegExp(/d/).test(value)) {
      return {
        digits : true
      };
    }

    return null;
  }
}
